// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__wXXit","shimmer":"Skeleton_shimmer__2bNtX"};